

//Blog filter 

  document.addEventListener('DOMContentLoaded', function() {
    const buttonShow = document.querySelector('.blog-articles-filter-btn .facets__button-show');
    const filterItemsWrapper = document.querySelector('.blog-filter-items-wrapper');
    if (!buttonShow || !filterItemsWrapper) return;

    buttonShow.addEventListener('click', function() {
      buttonShow.classList.toggle('active');
      filterItemsWrapper.classList.toggle('active');
    });
  });
document.addEventListener('DOMContentLoaded', function() {
    const facetButton = document.querySelector('.facets__button-show');
    const facetsContainer = document.querySelector('.facets__container');
    const productsGrid = document.querySelector('.products-grid');
    const collectionResults = document.querySelector('.collection-results');
    const labelShow = facetButton ? facetButton.querySelector('.label-show') : null;
    const labelHide = facetButton ? facetButton.querySelector('.label-hide') : null;
    
    // Function to set initial margins
    function setInitialMargins() {
        if (facetButton && facetsContainer && productsGrid) {
            let width = facetsContainer.offsetWidth + 32;
            facetsContainer.style.marginLeft = `-${width + 64}px`;
            productsGrid.style.marginLeft = `-${width}px`;
        }
    }
    
    // Set initial margins on page load
    setInitialMargins();
    
    if (facetButton) {
        facetButton.onclick = (event) => {
            event.currentTarget.querySelector('.label-show').classList.toggle('hidden');
            event.currentTarget.querySelector('.label-hide').classList.toggle('hidden');
            
            if (!event.currentTarget.classList.contains('facets__button-show_up')) {
                if (labelHide.classList.contains('hidden')) {
                    let width = facetsContainer.offsetWidth + 32;
                    facetsContainer.style.marginLeft = `-${width + 64}px`;
                    productsGrid.style.marginLeft = `-${width}px`;
                    console.log(width);
                } else {
                    facetsContainer.style.marginLeft = '0';
                    productsGrid.style.marginLeft = '0';
                }

                if (productsGrid)
                    productsGrid.classList.toggle('full-width');
                if (collectionResults)
                    collectionResults.classList.toggle('full-width');
            } else {
                if (labelHide.classList.contains('hidden')) {
                    let height = facetsContainer.offsetHeight;
                    document.querySelector('.facets__wrapper').style.marginTop = `-${height}px`;
                } else {
                    document.querySelector('.facets__wrapper').style.marginTop = '0';
                }
            }
        }
    }
});